import React from 'react'

import { Track } from "/react4xp/shared/track/track";

export default (props) => <Track {...props} />
